/**
 * Marketing / login site origin for unauthenticated redirects (no trailing slash).
 */
export function getLandingOrigin() {
  const raw = import.meta.env.VITE_LANDING_ORIGIN;
  const s = raw != null ? String(raw).trim() : "";
  if (s) return s.replace(/\/$/, "");
  if (import.meta.env.DEV) return "http://localhost:3000";
  return "";
}

/** Sign-in lives on this dashboard SPA (`/login`). Name kept for existing imports. */
export function getLandingLoginUrl() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/login`;
  }
  return "/login";
}
